import { useAuth0 } from '@auth0/auth0-react';
import { ThemeProvider } from '@emotion/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { GlobalFonts } from '../components/GlobalFonts';
import { setUser } from '../lib/monitoring/set-user';
import { useInitRum } from '../lib/monitoring/use-init-rum';
import Callback from '../pages/Callback/Callback';
import Login from '../pages/Login/Login';
import { SplitProvider } from '../split/SplitProvider';
import { theme } from '../theme';
import { Loading } from './App.style';
import { DefaultContent } from './DefaultContent';

export const queryClient = new QueryClient();

const App = () => {
  const { isLoading, user } = useAuth0();

  useEffect(() => {
    setUser(user);
  }, [user]);

  useInitRum();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ThemeProvider theme={theme}>
      <SplitProvider>
        <GlobalFonts />
        <QueryClientProvider client={queryClient}>
          <Routes>
            <Route Component={Login} path="/login" />
            <Route Component={Callback} path="/callback" />
            <Route Component={DefaultContent} path="*" />
          </Routes>
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        </QueryClientProvider>
      </SplitProvider>
    </ThemeProvider>
  );
};

export default App;
